import { z } from "zod";

import { DbEnum } from "../../../../../generated/prisma-enums";

/**
 * List Phone Number Requests Query Parameters
 *
 * For filtering and pagination of phone number requests.
 */
export const ListPhoneNumberRequestsParamsSchema = z.object({
  status: z
    .enum([...DbEnum.PHONE_NUMBER_REQUEST_STATUS_VALUES, "ALL"] as const)
    .optional()
    .default("ALL"),

  organizationId: z.string().min(1).optional(),

  countryCode: z.string().length(2).toUpperCase().optional(),

  limit: z.coerce.number().int().positive().max(100, "Maximum limit is 100").optional().default(20),

  offset: z.coerce.number().int().nonnegative().optional().default(0)
});

export type ListPhoneNumberRequestsParams = z.infer<typeof ListPhoneNumberRequestsParamsSchema>;
